const apiUrl = process.env.VUE_APP_API_BASEURL;

export default {
  savedPerson: `${apiUrl}/v2/user/savedPerson`,
  savedPersonById: (id: number) => `${apiUrl}/v2/user/savedPerson/${id}`,
  qualifiedBenefits: (customerUUID: string, communeId: number) =>
    `${apiUrl}/v2/user/${customerUUID}/qualifiedBenefits/${communeId}`,
  generatePrinterCode: (customerUUID: string, transactionId: number) =>
    `${apiUrl}/v2/user/${customerUUID}/printerCode/${transactionId}`,
  generateWalletPass: (customerUUID: string, taxId: string, os: string, userId: string) => {
    if (userId != '') {
      return `${apiUrl}/v2/user/${customerUUID}/walletPass/${taxId}?os=${os}&userId=${userId}`;
    }
    return `${apiUrl}/v2/user/${customerUUID}/walletPass/${taxId}?os=${os}`;
  },
  annualCandidate: `${apiUrl}/v2/user/annualCandidate`,
  userTransactions: (customerUUID: string) => `${apiUrl}/v2/user/${customerUUID}/transaction`,
};
